export default __webpack_public_path__ + "static/about-7fa28e82cf059ef6f5752499e3c57dd9.png";